import secureLocalStorage from "react-secure-storage";
import React, { Component } from "react";
import Images from "../../Assets/Images";
import { NavLink } from "react-router-dom";
import "../../Styles/UserAdmin.scss";
import { renderRoutes } from "react-router-config";
import { UserLoginRoute } from "../../Routes/RoutesPath";
import { Dialog } from "@progress/kendo-react-dialogs";
import { Dropdown } from "react-bootstrap";
import "react-dropzone-uploader/dist/styles.css";
import AuthContext from "../../Context/AuthContext";

class UserHeader extends Component {
  static contextType = AuthContext;
  
  constructor(props) {
    super(props);
    this.state = {
      showBrowse: false,
      ProfileDialogvisible: false,
      isDropdownVisible: false
    };
  }

  toggleProfileDialog = () => {
    this.setState({
      ProfileDialogvisible: !this.state.ProfileDialogvisible,
    });
  };

  showProfileUpload = () => {
    this.setState({ showBrowse: !this.state.showBrowse });
  };

  navigatePage = (nav) => {
    secureLocalStorage.setItem("ActivePage", nav);
    // Force a re-render to update the active tab
    this.forceUpdate();
  };

  pageNavLogout = () => {
    let userKey = secureLocalStorage.getItem("userKey");
    // secureLocalStorage.clear();
    // this.props.history.push(`/user/${userKey}`);
    window.location.href = `/${"user"}/${userKey}`;
  };

  changePassword = (e) => {
    debugger;
    e.preventDefault();
    let userKey = secureLocalStorage.getItem("userKey");
    this.props.history.push(`/user/${userKey}/home/dashboard/changepassword`);
  };
  componentDidMount() {
    // Set ActivePage based on current URL path
    this.updateActivePageFromURL();
    
    // Add event listener for popstate to handle browser navigation
    window.addEventListener('popstate', this.updateActivePageFromURL);
  }
  
  componentWillUnmount() {
    // Remove event listener when component unmounts
    window.removeEventListener('popstate', this.updateActivePageFromURL);
  }
  
  updateActivePageFromURL = () => {
    const currentPath = window.location.pathname;
    
    if (currentPath.includes('/home/main')) {
      secureLocalStorage.setItem('ActivePage', 'Home');
    } else if (currentPath.includes('/home/unit')) {
      secureLocalStorage.setItem('ActivePage', 'Risks');
    } else if (currentPath.includes('/home/taskmodule')) {
      secureLocalStorage.setItem('ActivePage', 'Task');
    } else if (currentPath.includes('/home/datasets')) {
      secureLocalStorage.setItem('ActivePage', 'Mitigations');
    } else if (currentPath.includes('/home/dashboard/reports')) {
      secureLocalStorage.setItem('ActivePage', 'Reports');
    } else if (currentPath.includes('/home/monteCarlo')) {
      secureLocalStorage.setItem('ActivePage', 'Analytics');
    } else if (currentPath.includes('/home/scenario')) {
      secureLocalStorage.setItem('ActivePage', 'Scenario');
    } else if (currentPath.includes('/home/admin')) {
      secureLocalStorage.setItem('ActivePage', 'Admin');
    } else if (currentPath.includes('/home/prime')) {
      secureLocalStorage.setItem('ActivePage', 'Prime');
    } else if (currentPath.includes('/home/cart')) {
      secureLocalStorage.setItem('ActivePage', 'Cart');
    }
  }
  
  openDemoVideo() {
   
  }
  
  handlePdfClick = () => {
    window.open('https://riskwellprotectuat.blob.core.windows.net/help/Riskwell-User-Manual.pdf', '_blank');
  };

 handleVimeoClick = () => {
  window.open('https://vimeo.com/showcase/protecttraining', '_blank');
};
    handleMouseEnter = () => {
    this.setState({
      isDropdownVisible: true,
    });
  };

   handleMouseLeave = () => {
    this.setState({
      isDropdownVisible: false,
    });
  };
 
  render() {
    let userKey = secureLocalStorage.getItem("userKey");
    let name = secureLocalStorage.getItem("userName");
    let role = secureLocalStorage.getItem("role");
    return (
      <div>
        <div className="appWrapperUser">
          <div className="wrapper">
            <div className="appHeader d-flex">
              <div className="heading">
                <a>
                  <img src={Images.RISKWELLLOGO} width="100" />
                </a>
              </div>
              <div className="ml-auto">
                <div className="d-flex">
                  <div className="appNav">
                    <ul>
                      {/* <li>
                        <NavLink exact to={`/user/${userKey}/home/main`}>
                          <a className="link active">
                            <span>
                              <img
                                src={Images.DASHBOARD}
                                width="13"
                                alt="Dashboard"
                              />
                            </span>
                            Dashboard
                          </a>
                        </NavLink>
                      </li>
                      <li>
                        <a className="link">
                          <span>
                            <img
                              src={Images.TIMELINE}
                              width="14"
                              alt="Timeline"
                            />
                          </span>
                          Scenarios
                        </a>
                      </li>
                      <li>
                        <a className="link">
                          <span>
                          <img
                            src={Images.VIEWLIST}
                            width="13"
                            alt="Viewlist"
                          />
                          </span>
                          Risk Tree
                        </a>
                      </li>
                      <li>
                        <a className="link">
                          <span>
                            <img
                              src={Images.ASSIGNMENT}
                              width="12"
                              alt="Assignment"
                            />
                          </span>
                          Programmes
                        </a>
                      </li> */}
                      <li>
                        <NavLink
                          className={`link ${
                            window.location.pathname.includes('/home/main') ? "Activated" : ""
                          }`}
                          to={`/user/${userKey}/home/main`}
                          onClick={() => this.navigatePage("Home")}
                        >
                          <span>
                            {" "}
                            <img src={Images.HOME} width="14" alt="Home" />{" "}
                          </span>
                          Home
                        </NavLink>
                      </li>
                      <li>
                        <NavLink
                          className={`link ${
                            window.location.pathname.includes('/home/unit')
                              ? "Activated"
                              : ""
                          }`}
                          exact
                          to={`/user/${userKey}/home/unit`}
                          onClick={() => this.navigatePage("Risks")}
                        >
                          <span>
                            {" "}
                            <img
                              src={Images.UNIT}
                              width="14"
                              alt="Risks"
                            />{" "}
                          </span>
                          Risks
                        </NavLink>
                      </li>
                      {this.context.hasPermission('tasks') && (
                      <li>
                        <NavLink
                          className={`link ${
                            window.location.pathname.includes('/home/taskmodule')
                              ? "Activated"
                              : ""
                          }`}
                          onClick={() => this.navigatePage("Task")}
                          exact
                          to={`/user/${userKey}/home/taskmodule`}
                        >
                          <span>
                            <img src={Images.TYPES} width="10" alt="Task" />
                          </span>
                          Tasks
                        </NavLink>
                      </li>
                    )}
                      <li>
                        <NavLink
                          className={`link ${
                            window.location.pathname.includes('/home/datasets')
                              ? "Activated"
                              : ""
                          }`}
                          exact
                          to={`/user/${userKey}/home/datasets`}
                          onClick={() => this.navigatePage("Mitigations")}
                        >
                          <span>
                            {" "}
                            <img
                              src={Images.TEMPLATE}
                              width="14"
                              alt="Mitigations"
                            />{" "}
                          </span>
                          Datasets
                        </NavLink>
                      </li>
                      <li>
                        <NavLink
                          id="reportActiveLink"
                          className={`link ${
                            window.location.pathname.includes('/home/dashboard/reports')
                              ? "Activated"
                              : ""
                          }`}
                          exact
                          to={`/user/${userKey}/home/dashboard/reports`}
                          onClick={() => this.navigatePage("Reports")}
                        >
                          <span>
                            {" "}
                            <img
                              src={Images.DASHBOARD}
                              width="13"
                              alt="Reports"
                            />{" "}
                          </span>
                          Reports
                        </NavLink>
                      </li>
                      <li>
                        <NavLink
                          className={`link ${
                            window.location.pathname.includes('/home/monteCarlo')
                              ? "Activated"
                              : ""
                          }`}
                          exact
                          to={`/user/${userKey}/home/monteCarlo`}
                          onClick={() => this.navigatePage("Analytics")}
                        >
                          <span>
                            {" "}
                            <img
                              src={Images.TEMPLATE}
                              width="14"
                              alt="Analytics"
                            />{" "}
                          </span>
                          Analytics
                        </NavLink>
                      </li>
                      <li>
                        <NavLink
                          className={`link ${
                            window.location.pathname.includes('/home/scenario')
                              ? "Activated"
                              : ""
                          }`}
                          exact
                          to={`/user/${userKey}/home/scenario`}
                          onClick={() => this.navigatePage("Scenario")}
                        >
                          <span>
                            {" "}
                            <img
                              src={Images.TEMPLATE}
                              width="14"
                              alt="Assignment"
                            />{" "}
                          </span>
                          Scenarios
                        </NavLink>
                      </li>
                      {this.context.hasPermission('admin') && (
                        <li>
                          <NavLink
                            className={`link ${
                                window.location.pathname.includes('/home/admin')
                                ? "Activated"
                                : ""
                            }`}
                            exact
                            to={`/user/${userKey}/home/admin`}
                            onClick={() => this.navigatePage("Admin")}
                          >
                            <span>
                              {" "}
                              <img
                                src={Images.USER}
                                width="14"
                                alt="Assignment"
                              />{" "}
                            </span>
                            Admin
                          </NavLink>
                        </li>
                      )}
                      {/* Prime tab - only visible if user has prime permission */}
                      {/* {this.context.hasPermission('prime') && (
                        <li>
                          <NavLink
                            className={`link ${
                              secureLocalStorage.getItem("ActivePage") == "Prime"
                                ? "Activated"
                                : ""
                            }`}
                            onClick={() => this.navigatePage("Prime")}
                            exact
                            to={`/user/${userKey}/home/prime`}
                          >
                            <span>
                              <img src={Images.TYPES} width="10" alt="Prime" />
                            </span>
                            Prime
                          </NavLink>
                        </li>
                      )} */}
                      <li className="cart">
                        <NavLink
                          className={`link ${
                            window.location.pathname.includes('/home/cart') ? "Activated" : ""
                          }`}
                          onClick={() => this.navigatePage("Cart")}
                          exact
                          to={`/user/${userKey}/home/cart`}
                        >
                          <span>
                            {" "}
                            <img
                              src={Images.EMAIL}
                              width="16"
                              alt="Assignment"
                            />{" "}
                          </span>
                          Email
                        </NavLink>
                      </li>
                      {/* <li>
                      <NavLink className="link" exact to={ `/user/${userKey}/home/admin`} >
                        <span> <img src={ Images.TEMPLATE }  width="14" alt="Assignment" /> </span>
                        Admin
                      </NavLink>
                    </li> */}
                      {/* <li>
                        <NavLink
                          className={`link ${
                            secureLocalStorage.getItem("ActivePage") == "Demo" ? "Activated" : ""
                          }`}
                          onClick={() => this.openDemoVideo()}
                          exact
                          to={`/user/${userKey}/home/demo`}
                        >
                          <span>
                            <img src={Images.PLAY} width="10" alt="Demo" />
                          </span>
                          Help
                        </NavLink>
                      </li> */}
                      <li>
                      <li
                        onMouseEnter={this.handleMouseEnter}
                        onMouseLeave={this.handleMouseLeave}
                        exact
                        className={`link help manual-link ${
                          secureLocalStorage.getItem("ActivePage") == "Demo" &&
                          ""
                        }`}
                        onClick={() => this.openDemoVideo()}
                        to={`/tenant/${userKey}/home/demo`}
                      >
                        <span>
                          <img src={Images.PLAY} width="10" alt="Demo" />
                        </span>
                        Help
                        {/* Dropdown menu, visible only when isDropdownVisible is true */}
                        {this.state.isDropdownVisible && (
                          <ul className="dropdown list-group">
                            <li
                              className="dropdown-option list-group-item"
                              onClick={this.handlePdfClick}
                            >
                              User Manual
                            </li>
                            <li
                              className="dropdown-option list-group-item"
                              onClick={this.handleVimeoClick}
                            >
                              Video Tutorials
                            </li>
                          </ul>
                        )}
                      </li>
                    </li>
                    </ul>
                  </div>
                  <div className="proImg">
                    {this.state.ProfileDialogvisible && (
                      <Dialog
                        onClose={this.toggleProfileDialog}
                        className="editProfileDialog"
                      >
                        <div className="addUnitForm">
                          <h3>Edit Profile</h3>
                          <div className="formCont">
                            <div className="fieldCol">
                              <div className="fieldCont">
                                <label>Name</label>
                                <input type="text"   autoComplete="off"/>
                              </div>
                            </div>
                            <div className="fieldCol">
                              <div className="fieldCont">
                                <label>Mobile Number</label>
                                <input type="text"   autoComplete="off"/>
                              </div>
                            </div>
                            <div className="fieldCol">
                              <div className="fieldCont">
                                <label>Telephone Number</label>
                                <input type="text"  autoComplete="off" />
                              </div>
                            </div>
                            <div className="fieldCol">
                              <div className="fieldCont">
                                <label>Email</label>
                                <input type="text"  autoComplete="off" />
                              </div>
                            </div>
                            <div className="fieldColTextarea">
                              <div className="fieldCont">
                                <label>Description</label>
                                <textarea></textarea>
                              </div>
                            </div>
                          </div>
                          <div className="btnGroup">
                            <button className="btnPrimary">Update</button>
                            <button
                              className="btnDark"
                              onClick={this.toggleProfileDialog}
                            >
                              Cancel
                            </button>
                          </div>
                        </div>
                      </Dialog>
                    )}

                    <div className="dropdown">
                      <a
                        className="imgCont dropdown-toggle"
                        data-toggle="dropdown"
                      >
                        {/* <img src={Images.AVATAR} width="20" alt="Profile" /> */}

                        <div className="profileImg">
                          <Dropdown>
                            <Dropdown.Toggle>
                              <div className="profileImg">
                                <img
                                  src={Images.AVATAR}
                                  width="20"
                                  alt="Profile"
                                />
                              </div>
                            </Dropdown.Toggle>
                            <Dropdown.Menu>
                              <div className="userProImgLarge">
                                <div>
                                  <div className="proImgWrapper">
                                    <img
                                      src={Images.AVATAR}
                                      width="30"
                                      alt="Profile"
                                    />

                                    {/* <a onClick={ this.showProfileUpload } className="updateProfile" title="Update"  >
                                      <img src={Images.UPLOADICON} width="10"/>
                                    </a> */}
                                    {/* <div className="dragAndDrop">
                                      <Dropzone
                                        onChangeStatus={this.handleChangeStatus}
                                        onSubmit={this.handleSubmit}
                                        submitButtonDisabled={(files) => files.length < 0}
                                        styles={{ dropzone: { minHeight: 40, maxHeight: 100 } }}
                                      />
                                    </div> */}
                                  </div>

                                  <h4>{name ? name.toUpperCase() : "NA"}</h4>
                                  {/* <p>
                                    {this.state.role
                                      ? this.state.role.toUpperCase()
                                      : "NA"}
                                  </p> */}
                                </div>
                              </div>
                              {/* <Dropdown.Item onClick={this.toggleProfileDialog}>
                                <img
                                  src={ Images.EDITICON } width="14"
                                />
                                Edit Profile
                              </Dropdown.Item> */}
                              <Dropdown.Item
                                onClick={(e) => this.changePassword(e)}
                              >
                                {" "}
                                <img
                                  src={Images.PASSWORD}
                                  width="14"
                                  alt="Password"
                                />
                                Change Password
                              </Dropdown.Item>
                              <Dropdown.Item onClick={this.pageNavLogout}>
                                <img
                                  src={Images.LOGOUT}
                                  width="14"
                                  alt="Profile"
                                />
                                Logout
                              </Dropdown.Item>
                            </Dropdown.Menu>
                          </Dropdown>
                        </div>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* <div className="proImg">
              <div className="dropdown">
                <a className="imgCont dropdown-toggle" data-toggle="dropdown">
                  <Dropdown>
                    <Dropdown.Toggle>
                      <div className="profileImg">
                        <img src={Images.AVATAR} width="22" alt="Profile" />
                      </div>
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                      
                      <Dropdown.Item onClick={(e) => this.changePassword(e)}>
                        {" "}
                        <img src={Images.PASSWORD} width="14" alt="Password" />
                        Change Password
                      </Dropdown.Item>
                      <Dropdown.Item onClick={this.pageNavLogout}>
                        <img src={Images.LOGOUT} width="14" alt="Profile" />
                        Logout
                      </Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>
                </a>
              </div>
            </div> */}

            <div className="adminContainer">
              {/* <Router> */}
              {/* <Switch> */}
              {renderRoutes(UserLoginRoute)}
              {/* </Switch> */}
              {/* </Router> */}
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default UserHeader;
